// latest: zhangmyh 2017-10-20 1:58 PM
import { Model } from 'common'
// 组织子表
Model.define('template.suitorg', {
  meta: {
    orgId: '',
    orgName: ''
  }
})



// WEBPACK FOOTER //
// ./src/data/model/qualifyTpl/suitOrgs.js